import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import parse from 'html-react-parser';

const Bookmarks = () => {
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem('bookmarks');
    if (stored) {
      setBookmarks(JSON.parse(stored));
    }
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Bookmarks
      </Typography>
      {bookmarks.length === 0 ? (
        <Typography>No bookmarks saved.</Typography>
      ) : (
        bookmarks.map((pair, index) => (
          <Paper key={index} sx={{ p: 2, mb: 2 }}>
   
            <Typography variant="body1">{pair.prompt}</Typography>
            
            <Accordion sx={{ mt: 1 }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`response-content-${index}`}
                id={`response-header-${index}`}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Response
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1">
                  {parse(pair.response)}
                </Typography>
              </AccordionDetails>
            </Accordion>
            
            <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
              Saved on: {new Date(pair.timestamp).toLocaleString()}
            </Typography>
          </Paper>
        ))
      )}
    </Box>
  );
};

export default Bookmarks;